<template>
    <div class="study">
        <studySearch @searchClick="searchClick" :sourceType="'study'"></studySearch>
        <!-- 默认：好书推荐（首页查看更多进入） -->
        <div class="book-list" v-show="!isSearchMode">
            <recommend-books />
        </div>
        <!-- 检索后：书目 / 条目结果 -->
        <div class="study-cont" v-if="isSearchMode">
            <el-tabs v-model="tabName" type="card" @tab-click="tab_click">
                <el-tab-pane
                    v-for="(item, index) in tabNav"
                    :key="index"
                    :label="`${item.val}(${item.num})`"
                    :name="item.type"
                ></el-tab-pane>
            </el-tabs>
            <div class="study-info">
                <bookList ref="bookList" v-show="tabName == '1'"></bookList>
                <articleList ref="articleList" v-show="tabName == '2'"></articleList>
            </div>
        </div>
    </div>
</template>

<script>
import studySearch from './comps/study_search.vue';
import bookList from './comps/book.vue';
import articleList from './comps/article.vue';
import RecommendBooks from './comps/recommend_books.vue';
import { mapState, mapMutations } from 'vuex';

export default {
    components: {
        studySearch,
        bookList,
        articleList,
        RecommendBooks,
    },
    data() {
        return {
            searchWord: this.$route.query.searchWord || '',
            tabName: '1',
            isSearchMode: false,
        };
    },
    computed: {
        ...mapState({
            searchVal: (state) => state.study.searchVal,
            tabNav: (state) => state.study.tabNav,
        }),
    },
    mounted() {
        // 带检索词进入时，直接展示检索结果区
        const word = this.searchVal || this.$route.query.searchWord || '';
        if (word) {
            this.isSearchMode = true;
            this.$nextTick(() => {
                this.refreshSearchResult();
            });
        }
    },
    methods: {
        ...mapMutations(['setSearchVal', 'setLeftNavIndex']),
        tab_click(tab) {
            this.tabName = tab.name;
            this.setLeftNavIndex('');
            this.$nextTick(() => {
                if (this.tabName == '1') {
                    this.$refs.bookList && this.$refs.bookList.init();
                } else if (this.tabName == '2') {
                    this.$refs.articleList && this.$refs.articleList.init();
                }
            });
        },
        searchClick() {
            const word = (this.searchVal || '').trim();
            // 无检索词：回到好书推荐
            if (!word) {
                this.isSearchMode = false;
                return;
            }
            this.isSearchMode = true;
            this.$nextTick(() => {
                this.refreshSearchResult();
            });
        },
        refreshSearchResult() {
            this.$refs.bookList && this.$refs.bookList.init('refresh');
            this.$refs.articleList && this.$refs.articleList.init('refresh');
        },
        advancedSearch() {},
    },
};
</script>

<style lang="less" scoped>
@import url('./study.less');
.study {
    min-width: 1200px;
    margin-bottom: 40px;

    .study-cont {
        width: 1200px;
        margin: 0 auto;
        ::v-deep .el-tabs__item {
            font-size: 16px;
            padding: 0 40px;
        }
        ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
            background: #F1F5FE;
            color: #386DE8;
        }
    }
}
</style>
